module.exports = __webpack_public_path__ + "static/media/your_seat.6ffeb3f7.jpg";